import React, { Component } from "react";
import { bot } from "../Images.js";
import { connect } from "react-redux";
import {
    siteDownMusic,
    siteDownMusicStop
} from "../../actions/actionCreators.js";

const mapDispatchToProps = (dispatch) => {
	return {
        siteDownMusic: () => dispatch(siteDownMusic()),
        siteDownMusicStop: () => dispatch(siteDownMusicStop())
	};
};

class SiteDownView extends Component {

    componentDidMount(){
        setTimeout( () => {
            this.props.siteDownMusicStop();
            this.props.next();
        }, 1500 );
        this.props.siteDownMusic();
    }

    render(){
        const imgStyles = { animation: `travel 4s cubic-bezier(.22,.48,.61,.99) forwards` };

        return (
            <div className="darkpatterns2dbg">
				<div className="bodyWrapper">
					<div className="body">
                        <div className="site_down">
                            <div className="overbot_texture"></div>
                            <div className="color_flickr"></div>
                            <div className="technical_difficulty">Sorry, We are experiencing technical difficulties :(</div>
                            <div className="graphic">
                                <img src={bot} alt="bot" style={imgStyles}/>
                            </div>
                            <div className="technical_reason">Don't be sad human. It will all be over soon.</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const SiteDown = connect(() => ({}), mapDispatchToProps)(SiteDownView);
export default SiteDown;


// WEBPACK FOOTER //
// ./src/components/scenes/SiteDown.js